import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Invitations from '../../components/invitations/Invitations';

import * as organizationInvitationSelector from '../../selectors/organizationInvitationsSelector';
import * as organizationSelectors from '../../selectors/organizationSelectors';

import { INVITATION_USER_ACTIONS } from '../../enums/UserActions';

const INVITATION_ACTIONS = Object.keys(INVITATION_USER_ACTIONS);

const OrganizationInvitationList = props => {
    const { invitations, onInvitationAction, isAdmin } = props;

    if (!isAdmin) {
        return null;
    }

    return (
        <Invitations
            invitations={invitations}
            actions={INVITATION_ACTIONS}
            onAction={onInvitationAction}
        />
    );
};

OrganizationInvitationList.propTypes = {
    invitations: PropTypes.array,
    onInvitationAction: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool,
};

OrganizationInvitationList.defaultProps = {
    invitations: [],
    isAdmin: false,
};

const mapStateToProps = state => ({
    invitations: organizationInvitationSelector.getInvitations(state),
    isAdmin: organizationSelectors.getIsCurrentUserAdminForOrganization(state),
});

const mapDispatchToProps = dispatch => ({
    onInvitationAction: (invitation, action) =>
        dispatch({
            type: INVITATION_USER_ACTIONS[action],
            payload: { invitation },
        }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(OrganizationInvitationList);



// WEBPACK FOOTER //
// ./src/containers/organizationMembers/OrganizationInvitationList.js